import { tap, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { DeleteCommand, standardCommand } from '../../../core/model/command';
import { ModelBase } from '../../../core/model/model-base';
import { DataService } from '../../../core/service/base/data.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../navigation.service';
import { LanguageService } from '../language.service';
import { EMPTY, Observable } from 'rxjs';

@Injectable()
export class DeleteFormCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: DataService<ModelBase>,
    private _messageService: MessageService,
    private _navigation: NavigationService,
    private _translateService: LanguageService
  ) {}

  canExecute(command: DeleteCommand): boolean {
    if (!command.context) {
      return false;
    }
    if (command.context.isNew) {
      this._messageService.showWarning('WARNING.DELETE_NEW');
      return false;
    }
    return command.id === standardCommand.delete && command.context;
  }

  execute(command: DeleteCommand): Observable<void> {
    if (!command.context) {
      throw new Error('Context is null');
    }
    
    return this._messageService
      .showDialog('DO_YOU_WANT_TO_DELETE_TEXT', { value: command.context.toString(this._translateService.currentLanguage) })
      .pipe(
        switchMap(dialogResult => {
          if (dialogResult) {
            return this._dataService.delete(command.context.id).pipe(tap(() => this._navigation.navigateToList()));
          }
          return EMPTY;
        })
      );
  }
}
